export enum ProcessClrTypeID {
    /**
     * 流程typeId
     */
    process = 'bpmn.Process',
    /**
     * 开始活动typeId
     */
    startActivity = 'wf.StartActivity',
    /**
     * 活动节点typeId
     */
    userActivity = 'wf.UserActivity',
    /**
     * 人工操作typeId
     */
    operationActivity = 'wf.OperationActivity',
    /**
     * 结束活动typeId
     */
    endEvent = 'bpmn.EndEvent',
    /**
     * 流转线typeId
     */
    sequenceFlow = 'bpmn.SequenceFlow',
    /**
     * 排他网关typeId
     */
    exclusiveGateway = 'bpmn.ExclusiveGateway',
    /**
     * 并行网关typeId
     */
    parallelGateway = 'bpmn.ParallelGateway',

    /**
     * 子流程
     */
    subProcess = 'wf.CallActivitySubProcess',

    /**
     * 服务活动
     */
    autoActivity = 'wf.AutoActivity',

    /**
     * 信号捕获
     */
    catchEvent = 'wf.IntermediateCatchEventImpl',

    /**
     * 消息
     */
    messageActivity = 'wf.MessageActivity',

    /**
     * 知会活动
     */
    notifyActivity = "wf.NotifyActivity",

    /**
     * 生单活动
     */
    aifCreationBillActivity = "wf.AifCreationBillActivity",

    billNodeActivity = "wf.AifBillNodeActivity",

    sequenceActivity = "wf.AifSequenceActivity",
}
